import { X } from "lucide-react";

export default function FilterChip({

  label,
  value,
  onRemove

}) {

  if (!value) return null;

  return (

    <div
      className="
      flex
      items-center
      gap-2
      bg-primary
      text-white
      px-4
      py-2
      rounded-full
      text-sm
      font-semibold
      shadow-sm
    "
    >

      <span>

        {label}: {value}

      </span>

      <button
        onClick={onRemove}
        className="
        hover:bg-white/20
        rounded-full
        p-1
        transition
      "
      >

        <X size={14} />

      </button>

    </div>
  );
}